import axios from 'axios';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import { cacheAdapterEnhancer, Cache } from 'axios-extensions';

const cache = new Cache({ maxAge: 5 * 1000 });

const axiosConfig = {
  withCredentials: false,
  headers: {},
  adapter: cacheAdapterEnhancer(axios.defaults.adapter, { defaultCache: cache })
};

let cachedAxios = axios.create(axiosConfig);

export  { cachedAxios, cache };


// WEBPACK FOOTER //
// ./src/cachedAxios.js